<template>
  <div class="card" :class="mobileCardClassName" :style="{ width: cardWidth + 'px', flexShrink: '0' }">
    <div style="gap: 10px; height: 100%">
      <div class="bank-carousel-card">
        <div class="bank-carousel-fdic-decoration">
          <div class="bank-carousel-fdic-text">
            {{ model?.bank?.federallyInsured ? 'Member ' + model.bank.sourceName : '' }}
          </div>
        </div>
        <div class="bank-carousel-logo-apy">
          <div style="align-self: stretch">
            <img style="max-width: 85px; max-height: 70px" :src="`/content/logos/${model?.account?.bankUrl}.gif`"
              alt="Bank Logo" />
          </div>
          <div class="bank-carousel-logo-spacer"></div>
          <div style="text-align: right">
            <div class="apy-container bank-carousel-tooltip">
              APY
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 16 16" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM7.125 12.0444C7.125 11.5612 7.51675 11.1694 8 11.1694C8.48325 11.1694 8.875 11.5612 8.875 12.0444C8.875 12.5276 8.48325 12.9194 8 12.9194C7.51675 12.9194 7.125 12.5276 7.125 12.0444ZM7.96873 4.86324C8.40972 4.84626 8.74442 4.97778 8.96239 5.17401C9.17609 5.36639 9.32295 5.66083 9.32295 6.0684C9.32295 6.40709 9.247 6.57333 9.13953 6.71392C9.01673 6.87456 8.84807 7.01367 8.56145 7.25006C8.51444 7.28883 8.46416 7.3303 8.41048 7.37483L8.39669 7.38514C8.3781 7.39919 8.35254 7.41884 8.32195 7.44324C8.26126 7.49163 8.17826 7.56068 8.0893 7.64339C7.93557 7.78633 7.67307 8.05118 7.55105 8.36696C7.47462 8.56479 7.4234 8.75745 7.39154 8.89641C7.37535 8.96705 7.36354 9.02656 7.3556 9.06947C7.35163 9.09098 7.3486 9.10848 7.34645 9.1213L7.34389 9.13697L7.34309 9.14205L7.34281 9.14387L7.34265 9.14492C7.34264 9.14499 7.34261 9.14521 7.96054 9.23894L7.34265 9.14492C7.29088 9.4862 7.52553 9.80511 7.86681 9.85688C8.20797 9.90862 8.52649 9.67411 8.57842 9.33302C8.57841 9.33309 8.57843 9.33295 8.57842 9.33302L8.57935 9.32737C8.58039 9.32114 8.58219 9.3107 8.58478 9.29669C8.58998 9.26855 8.59827 9.22663 8.60993 9.17574C8.63379 9.07168 8.66933 8.94098 8.71704 8.81748C8.71772 8.81604 8.73184 8.78593 8.7784 8.72864C8.82266 8.67417 8.8793 8.61569 8.94045 8.55884C9.00059 8.50292 9.05842 8.45473 9.1013 8.42054C9.12248 8.40365 9.13939 8.39067 9.15031 8.38242L9.16182 8.37381L9.16289 8.37301L9.17972 8.36084L9.19583 8.34746C9.24132 8.30969 9.28794 8.27151 9.33517 8.23283C9.61389 8.00458 9.91446 7.75843 10.1326 7.47306C10.425 7.09062 10.5729 6.64985 10.5729 6.0684C10.5729 5.33644 10.2972 4.69375 9.79874 4.24502C9.30457 3.80014 8.63765 3.58656 7.92064 3.61417C6.91536 3.65287 6.2512 4.07926 5.86497 4.6724C5.50455 5.2259 5.43281 5.85256 5.42707 6.24866C5.42207 6.5938 5.69781 6.87765 6.04295 6.88265C6.38809 6.88765 6.67194 6.61191 6.67694 6.26676C6.68118 5.97385 6.73795 5.6225 6.91247 5.35449C7.06117 5.12612 7.33836 4.88751 7.96873 4.86324Z"
                  fill="#0069BA" />
              </svg>
              <span class="bank-carousel-apy bank-carousel-tooltiptext">
                APY = Annual Percentage Yield Rates as of {{ formattedDate }}
              </span>
            </div>
            <div class="bank-carousel-apy-rate">
              {{ model?.account?.apy?.toFixed(2) }}%
            </div>
          </div>
        </div>
        <div class="bank-carousel-our-rating">
          <div class="bank-carousel-our-rating-text">Our Rating</div>
          <div class="bank-carousel-rating-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M7.36025 0L5.62261 5.34734L0 5.34749L4.54867 8.65251L2.81135 14L7.36025 10.6953L11.9091 14L10.1718 8.65251L14.7205 5.34749L9.09789 5.34734L7.36025 0Z"
                fill="#FFC507" />
            </svg>
            <span class="bank-carousel-our-rating-star-rating">{{ ratingDisplay }}</span>
            <span class="bank-carousel-our-rating-total-star-rating"> / 5</span>
          </div>
        </div>
        <div class="bank-carousel-card-line"></div>
        <div class="bank-carousel-bankname-productname-text">
          <div class="bank-carousel-bankname">
            <span class="bank-carousel-bankname-text">{{ model?.account?.bankName }}</span>
          </div>
          <div class="bank-carousel-product">
            <span class="bank-carousel-product-text">{{ model?.account?.name }}</span>
          </div>
        </div>
        <div class="bank-carousel-see-offer">
          <a class="bank-carousel-see-offer-button" :href="model.trackedLink"
            :data-adselector="zoneKey === 'da-bp-carouseltop' ? `BankPageTopCarousel[${index}]` : `BankPageBottomCarousel[${index}]`"
            rel="nofollow" @click="logAdClickV2($event, model.trackedLink)" target="_blank">
            <span class="bank-carousel-see-offer-button-text">See Offer</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
              <path
                d="M5.5 5.25C5.36193 5.25 5.25 5.36193 5.25 5.5V19.5C5.25 19.6381 5.36193 19.75 5.5 19.75H19.5C19.6381 19.75 19.75 19.6381 19.75 19.5V14.269C19.75 13.8547 20.0858 13.519 20.5 13.519C20.9142 13.519 21.25 13.8547 21.25 14.269V19.5C21.25 20.4665 20.4665 21.25 19.5 21.25H5.5C4.5335 21.25 3.75 20.4665 3.75 19.5V5.5C3.75 4.5335 4.5335 3.75 5.5 3.75H10.7111C11.1253 3.75 11.4611 4.08579 11.4611 4.5C11.4611 4.91421 11.1253 5.25 10.7111 5.25H5.5Z"
                fill="white" />
              <path
                d="M13.611 4.5C13.611 4.08579 13.9468 3.75 14.361 3.75001L20.5765 3.75005C20.9963 3.75005 21.3365 4.09029 21.3365 4.51004L21.3366 10.5525C21.3366 10.9667 21.0008 11.3025 20.5866 11.3025C20.1724 11.3025 19.8366 10.9667 19.8366 10.5525L19.8365 5.8892L8.46696 17.2586C8.17406 17.5515 7.69919 17.5515 7.4063 17.2586C7.11341 16.9657 7.11342 16.4908 7.40632 16.1979L18.3544 5.25003L14.361 5.25001C13.9467 5.25 13.611 4.91421 13.611 4.5Z"
                fill="white" />
            </svg>
          </a>
        </div>
        <div v-if="model.adCopy" class="bank-carousel-sponsornote">
          <span class="bank-carousel-sponsornote-note">Sponsored Note:
            <span class="bank-carousel-sponsornote-note-detail">{{ model.adCopy }}</span></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, computed, onMounted, defineComponent, PropType, toRefs } from 'vue';
import { AdPlacement, RatingData } from '../../common/adModels';
import analytics from "../../services/analytics";

const { logAdClick } = analytics

interface Props {
  index: number
  model: AdPlacement;
  zoneKey: string;
  ratingsData: RatingData[];
  slideCount: number;
  cardWidth: number;
}

export default defineComponent({
  props: {
    index: {
      type: Number,
      required: true,
    },
    model: {
      type: Object as PropType<AdPlacement>,
      required: true,
    },
    zoneKey: {
      type: String,
      required: true,
    },
    ratingsData: {
      type: Array as PropType<RatingData[]>,
      required: true
    },
    slideCount: {
      type: Number,
      required: true,
    },
    cardWidth: {
      type: Number,
      required: true,
    }
  },
  setup(props: Props) {
    const { model, ratingsData, slideCount } = toRefs(props);
    const ratingDisplay = ref<string | null>("-");
    onMounted(() => {
      try {
        if (ratingsData.value && ratingsData.value.length > 0) {
          const ratingData = ratingsData.value.find(q => q.bankId === model.value.account.bankId);
          if (ratingData) {
            const bankStarRating = ratingData.bankStarRatings.find(q => q.bankRatingCategoryId === 1);
            if (bankStarRating) {
              ratingDisplay.value = bankStarRating.rating.toFixed(1);
            } else {
              console.warn(`No bankStarRating with category 1 found for bankId: ${model.value.account.bankId}`);
            }
          } else {
            console.warn(`No rating data found for bankId: ${model.value.account.bankId}`);
          }
        } else {
          console.warn("ratingsData is empty or undefined");
        }
      } catch (error) {
        console.error("Error fetching rating:", error);
        ratingDisplay.value = "-";
      }
    });

    const currentDate = new Date();
    const formattedDate = computed(() => {
      const month = currentDate.getMonth() + 1;
      const day = currentDate.getDate();
      const year = currentDate.getFullYear();
      return `${month}/${day}/${year}`;
    });

    const mobileCardClassName = computed(() => {
      return slideCount.value == 1 ? 'mobile-card-full-width' : '';
    });

    const logAdClickV2 = (event: Event, trackedLink: string) => {
      const adPlacement: AdPlacement = {
        ...model.value,
        nonSponsoredAd: model.value.nonSponsoredAd || false,
        position: model.value.position || 0,
        keyName: model.value.keyName || '',
        account: {
          id: 0,
          termInDays: 0,
          minToOpen: 0,
          sectionId: 0,
          bonusAmount: 0,
          monthlyServiceCharge: 0,
          bankNameOverride: model.value.account.bankNameOverride,
          sectionName: model.value.account.sectionName,
          bankUrl: model.value.account.bankUrl,
          bankName: model.value.account.bankName,
          name: model.value.account.name,
          bankId: model.value.account.bankId,
          apy: model.value.account.apy,
          min: model.value.account.min,
          max: model.value.account.max,
        },
        bank: {
          federallyInsured: model.value.bank.federallyInsured !== undefined ? model.value.bank.federallyInsured : false,
          sourceName: model.value.bank.sourceName !== undefined ? model.value.bank.sourceName : "",
          healthGrade: model.value.bank.healthGrade !== undefined ? model.value.bank.healthGrade : "",
        }
      };
      logAdClick(adPlacement);
    };

    return {
      formattedDate,
      ratingDisplay,
      logAdClickV2,
      mobileCardClassName
    };
  },
});
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

img {
  vertical-align: middle;
}

.text {
  color: #f2f2f2;
  font-size: 15px;
  padding: 8px 12px;
  position: absolute;
  bottom: 8px;
  width: 100%;
  text-align: center;
}

.numbertext {
  color: #f2f2f2;
  font-size: 12px;
  padding: 8px 12px;
  position: absolute;
  top: 0;
}

.dot {
  cursor: pointer;
  height: 10px;
  width: 10px;
  margin: 0 2px;
  background-color: #a0acb1;
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.6s ease;
}

.active-dot {
  background-color: #101f30;
  width: 40px;
  border-radius: 200px;
}

.bank-carousel-card {
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacer-0, 0px);
  align-self: stretch;
  border-radius: 8px;
  background: var(--Grays-white, #fff);
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
  max-width: 99%;
  word-wrap: break-word;
  height: 100%;
}

.bank-carousel-fdic-decoration {
  display: flex;
  padding: 5px 11px;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: #f1f8ff;
  margin-bottom: 0.75rem;
}

.bank-carousel-fdic-text {
  color: #002a4a;
  text-align: center;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: 75%;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.bank-carousel-logo-apy {
  display: flex;
  height: 70px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}

.bank-carousel-logo-spacer {
  display: flex;
  height: 70px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}

.bank-carousel-apy {
  color: var(--Grays-lt-gray-darken-1, var(--Grays-lt-gray-darken-1, #848e92));
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin-bottom: 0;
}

.bank-carousel-apy-rate {
  color: var(--Primary-lt-deep-blue, var(--Primary-lt-deep-blue, #101f30));
  font-size: 27px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  padding-right: 4px;
}

.bank-carousel-our-rating {
  display: flex;
  padding: var(--spacer-0, 0px);
  justify-content: flex-end;
  align-items: center;
  gap: var(--spacer-8, 8px);
  margin-bottom: 8px;
}

.bank-carousel-our-rating-text {
  color: #003f70;
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
}

.bank-carousel-rating-wrapper {
  display: flex;
  align-items: center;

  svg {
    margin-right: 4px;
  }
}

.bank-carousel-our-rating-star-rating {
  color: #101f30;
  text-align: right;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}

.bank-carousel-our-rating-total-star-rating {
  color: #687073;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin-top: 0.35rem;
}

.bank-carousel-card-line {
  display: flex;
  padding: 1px 0 0;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacer-0, 0px);
  align-self: stretch;
  background: var(--Grays-lt-gray-lighten-2, #e3e6e8);
}

.bank-carousel-bankname {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  padding-top: 8px;
}

.bank-carousel-bankname-productname-text {
  height: 70px;
  width: 100%;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.bank-carousel-bankname-text {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.bank-carousel-bankname-text::-webkit-scrollbar {
  display: none;
}

.bank-carousel-bankname-text {
  color: black;
  font-feature-settings: 'liga' off, 'clig' off;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  max-height: 35px;
  overflow: auto;
  max-width: 100%;
}

.bank-carousel-product {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  width: 100%;
  flex-wrap: nowrap;
}

.bank-carousel-product-text {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.bank-carousel-product-text::-webkit-scrollbar {
  display: none;
}

.bank-carousel-product-text {
  color: #0069ba;
  font-feature-settings: 'liga' off, 'clig' off;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  hyphens: auto;
  word-wrap: break-word;
  max-height: 35px;
  overflow: auto;
}

.bank-carousel-see-offer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacer-12, 12px);
  align-self: stretch;
  margin: 12px 0;
}

.bank-carousel-see-offer-button {
  display: flex;
  height: 35px;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 60px;
  background: #0069ba;
  width: 100%;
  text-decoration: none;
}

.bank-carousel-see-offer-button-text {
  color: white;
  text-align: right;
  font-feature-settings: 'liga' off, 'clig' off;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}

.bank-carousel-sponsornote {
  display: flex;
  padding: var(--spacer-4, 4px);
  margin-top: 8px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: var(--spacer-1, 4px);
  background: #f1f8ff;
}

.bank-carousel-sponsornote-note {
  color: #454545;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
}

.bank-carousel-sponsornote-note-detail {
  color: #454545;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(10%);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideOut {
  from {
    opacity: 1;
    transform: translateX(0);
  }

  to {
    opacity: 0;
    transform: translateX(-10%);
  }
}

.slide-in {
  animation: slideIn 3s forwards;
}

.slide-out {
  animation: slideOut 3s forwards;
}

.hidden {
  display: none;
}

.bank-carousel-mobile {
  display: none;
  margin-bottom: 8px;
}

.bank-carousel-desktop {
  display: block;
  margin-bottom: 8px;
}

@media (max-width: 575px) {
  .bank-carousel-mobile {
    display: block;
  }

  .bank-carousel-desktop {
    display: none;
  }

  .bank-carousel-card {
    max-width: 100%;
    height: 100%;
  }
}

@media (min-width: 576px) {}

@media (max-width: 768px) {
  .apy-container {
    display: flex;
    justify-content: flex-end;
    gap: 5px;
  }
}

@media (min-width: 576px) and (max-width: 768px) {
  .bank-carousel-mobile {
    display: block;
  }

  .bank-carousel-desktop {
    display: none;
  }
}

@media (min-width: 576px) and (max-width: 991px) {}

@media (min-width: 992px) {}

.bank-carousel-tooltip {
  position: relative;
  display: inline-block;
}

.bank-carousel-tooltip .bank-carousel-tooltiptext {
  visibility: hidden;
  width: 380%;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  top: -5px;
  right: 50%;
}

.bank-carousel-tooltip .bank-carousel-tooltiptext::after {
  content: " ";
  position: absolute;
  top: 20%;
  left: 98%;
  margin-top: -5px;
  border-width: 10px;
  border-style: solid;
  border-color: transparent transparent transparent black;
}

.bank-carousel-tooltip:hover .bank-carousel-tooltiptext {
  visibility: visible;
}

.card {
  border-radius: 8px;
  scroll-snap-align: start;
  flex-shrink: 0;
}

.carouselNav-container {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 15px;
  background-color: #F1F8FF;
}

@media (max-width: 768px) {

  .card {
    flex: 0 0 80%;
  }

  .mobile-card-full-width {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

@media (max-width: 575px) {

  .card {
    flex: 0 0 80%;
  }

  .mobile-card-full-width {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>
